module.exports = __webpack_public_path__ + "img/brabant-persona.0d9173fe.svg";